// extracted by mini-css-extract-plugin
module.exports = {"money":"money-DHk3Z","currency_before":"currency_before-c1n_N"};